import { Valor } from '@/componentes/valor';

import { Capitulo, NaoPreenchido } from './ficha';

/* As últimas visitas: uma linha por sessão de uso, não por requisição. */
export function Visitas({ acessos }: { acessos: { criado_em: string }[] }) {
  return (
    <Capitulo titulo="Visitas" descricao="As cinquenta mais recentes, uma por sessão de uso.">
      {acessos.length === 0 ? (
        <NaoPreenchido>Nenhuma visita registrada. A contagem começou com o painel.</NaoPreenchido>
      ) : (
        <ul className="grid gap-1">
          {acessos.map((acesso) => (
            <li key={acesso.criado_em}>
              <Valor valor={acesso.criado_em} formato="data" tamanho="apoio" />
            </li>
          ))}
        </ul>
      )}
    </Capitulo>
  );
}
